import React, {useContext, useState, useRef, useEffect, forwardRef} from 'react';
import { useForm } from 'react-hook-form'; // Asegúrate de tener la importación de useForm
import { zodResolver } from "@hookform/resolvers/zod";
import { userSchema } from "../validations/userSchema";
import { AuthContext } from '../context/authContext';
import { Input, Label, Button } from "../components/ui";


// ... Importaciones de componentes UI (Input, Label, Button, FormField) y AuthContext ...

export const RegisterPage = () => {
    // ... Contexto y estados (loading, message, messageType, firstInputRef) ...
    const { login, setUser } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const firstInputRef = useRef(null);

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm({
        resolver: zodResolver(userSchema)//,  <-- COMENTA O ELIMINA ESTA LÍNEA (Desactivamos validación temporalmente)
    });

    const onSubmit = async (data) => {
        console.log("Formulario con MULTIPLES CAMPOS (SIN VALIDACION) onSubmit llamado!", data); // <-- console.log
        try {
            const response = await fetch(`/api/authentication/register`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data)
            });

            const responseData = await response.json();

            if (!response.ok || !responseData.success) {
                throw new Error(responseData.message || 'Registration failed');
            }

            // No auto-login - mostrar mensaje de verificacion pendiente
            setMessage(responseData.message || 'Registro exitoso. Su cuenta está pendiente de verificación.');
            setMessageType('success');
        } catch (error) {
            console.error("Registration error:", error.message);
            setMessage(error.message);
            setMessageType('error');
        }
    };

    console.log("Errores de validación:", errors);

    return (
        <div className="flex min-h-screen flex-1 flex-col justify-center px-6 py-12 lg:px-8 bg-gray-50 dark:bg-gray-900">
            {message && (
                <div className={`mb-4 p-4 rounded-md text-sm ${
                    messageType === 'success'
                        ? 'bg-green-100 text-green-800 border border-green-300'
                        : 'bg-red-100 text-red-800 border border-red-300'
                }`}>
                    {message}
                </div>
            )}
            <form className="space-y-6" onSubmit={handleSubmit(onSubmit)} noValidate>
                {/* Campos del formulario (reutilizando FormField) */}
                {['username', 'email', 'password', 'confirmPassword'].map((field, index) => (
                    <FormField
                        key={field}
                        field={field}
                        register={register} // <-- Seguimos pasando register
                        errors={errors}     // <-- Seguimos pasando errors (aunque no habrá errores de validación por ahora)
                        inputRef={index === 0 ? firstInputRef : null}
                    />
                ))}

                <div>
                    <Button type="submit" disabled={loading} className="w-full">
                        {loading ? /* ... (Spinner) ... */ null : 'Registrarse'}
                    </Button>
                </div>
            </form>
            {/* ... (Div de debugging watch()) ... */}
        </div>
    );
};

// Componente reutilizable para campos del formulario
const FormField = ({ field, register, errors }) => {
    const fieldConfig = {
        password: { type: 'password', placeholder: '********' },
        confirmPassword: { type: 'password', placeholder: '********' },
        email: { type: 'email', placeholder: 'correo@gmail.com' },
        username: { type: 'text', placeholder: 'yourUser123' }
    };

    return (
        <div>
            <Label htmlFor={field}>
                {field.replace(/([A-Z])/g, ' $1')}
            </Label>
            <div className="mt-2">
                <Input
                    id={field}
                    type={fieldConfig[field]?.type || 'text'}
                    placeholder={fieldConfig[field]?.placeholder}
                    {...register(field)}
                />
                {errors[field]?.message && (
                    <p className="text-red-500 text-sm mt-1">{errors[field].message}</p>
                )}
            </div>
        </div>
    );
};

// ... (Componente FormField - déjalo como está por ahora) ...